import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { jsx as _jsx } from "react/jsx-runtime";
export function TablePaginator({
  currentPage,
  hasMore,
  hasPrev,
  onNextPage,
  onPrevPage,
  loading = false
}) {
  if (!hasMore && !hasPrev) {
    return null;
  }

  // Only expose currentPage+1 as total pageCount
  const pageCount = hasMore ? currentPage + 1 : currentPage;
  function handlePageChange({
    target: {
      value: newPage
    }
  }) {
    if (loading) {
      return;
    }
    if (newPage === currentPage + 1) {
      onNextPage === null || onNextPage === void 0 || onNextPage();
    } else if (newPage === currentPage - 1) {
      onPrevPage === null || onPrevPage === void 0 || onPrevPage();
    }
  }
  return /*#__PURE__*/_jsx(Paginator, {
    page: currentPage,
    pageCount: pageCount,
    maxVisiblePageButtons: 3,
    onPageChange: handlePageChange
  });
}